import React from 'react';
import { Paper, Slide, useTheme, useMediaQuery } from '@mui/material';

interface CopilotWindowProps {
  isOpen: boolean;
  chatWindowRef: React.RefObject<HTMLDivElement>;
  isActivating: boolean;
  children: React.ReactNode;
}

export const CopilotWindow: React.FC<CopilotWindowProps> = ({ isOpen, chatWindowRef, isActivating, children }) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  const paperContent = (
    <Paper
      ref={chatWindowRef}
      elevation={0}
      role="dialog"
      aria-label="LOGIX Copilot Window"
      sx={{
        position: isMobileOrTablet ? 'fixed' : 'relative',
        top: isMobileOrTablet ? 0 : 'auto',
        right: isMobileOrTablet ? 0 : 'auto',
        bottom: isMobileOrTablet ? 0 : 'auto',
        width: isMobileOrTablet ? { xs: '100%', sm: 360 } : 360,
        height: isMobileOrTablet ? 'var(--layout-height)' : '100%',
        backgroundColor: '#FFFFFF',
        border: isMobileOrTablet ? '2px solid transparent' : `1px solid ${theme.palette.divider}`,
        borderRight: isMobileOrTablet ? 'none' : undefined,
        borderRadius: isMobileOrTablet ? 0 : '16px',
        boxShadow: isMobileOrTablet
          ? '-8px 0px 32px rgba(0, 0, 0, 0.08)'
          : `0 8px 32px 0 ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(0, 0, 0, 0.2)'}`,
        display: 'flex',
        flexDirection: 'column',
        zIndex: isMobileOrTablet ? 9999 : 1,
        overflow: 'hidden',
        animation: isActivating ? 'geminiBorderGlowLoop 3s linear infinite' : 'none',
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
        visibility: isMobileOrTablet ? 'visible' : isOpen ? 'visible' : 'hidden',
      }}
    >
      {children}
    </Paper>
  );

  if (isMobileOrTablet) {
    return (
      <Slide direction="left" in={isOpen} mountOnEnter unmountOnExit>
        {paperContent}
      </Slide>
    );
  }

  return paperContent;
};

CopilotWindow.displayName = 'CopilotWindow';
